/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChartDataDto
 */
export interface ChartDataDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChartDataDto
     */
    labels: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    data: Array<number> | null;
}

/**
 * Check if a given object implements the ChartDataDto interface.
 */
export function instanceOfChartDataDto(value: object): value is ChartDataDto {
    if (!('labels' in value) || value['labels'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ChartDataDtoFromJSON(json: any): ChartDataDto {
    return ChartDataDtoFromJSONTyped(json, false);
}

export function ChartDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'] == null ? null : json['labels'],
        'data': json['data'] == null ? null : json['data'],
    };
}

export function ChartDataDtoToJSON(json: any): ChartDataDto {
    return ChartDataDtoToJSONTyped(json, false);
}

export function ChartDataDtoToJSONTyped(value?: ChartDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'],
        'data': value['data'],
    };
}

